import React, { useState } from 'react';
import Navbar from './Navbar';
import useBrochure from './Brochure';
import EnessaLogo from '../assets/logo/Enessa-Logo-2.png';
import { Link } from 'react-router-dom';

const Header = () => {
  const {
    showModal,
    formData,
    updateField,
    downloadBrochure,
    closeModal,
    handleSubmit,
  } = useBrochure();

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <header className="relative z-10 p-4 bg-white lg:px-8 lg:bg-transparent">
        <div className="flex items-center gap-4">

          <div className="flex-shrink-0">
            <Link to="/" className="block">
              <img src={EnessaLogo} alt="logo" className="h-20 lg:h-26" />
            </Link>
          </div>

          <Navbar />

          <div className="items-center flex-shrink-0 hidden min-w-0 gap-2 lg:flex xl:gap-4">
            <button
              onClick={downloadBrochure}
              className="px-3 py-2 md:px-4 md:py-2 lg:px-4 lg:py-2 xl:px-6 xl:py-3
                text-[12px] md:text-sm lg:text-sm xl:text-base font-medium transition-all
                border-2 rounded-full border-slate-700 text-slate-700
                hover:bg-slate-700 hover:text-white whitespace-nowrap shrink min-w-0"
            >
              Download Brochure
            </button>

            <Link
              to="/contact#inquiry-section"
              className="px-3 py-2 md:px-4 md:py-2 lg:px-4 lg:py-2 xl:px-6 xl:py-3
                text-[12px] md:text-sm lg:text-sm xl:text-base font-medium text-white
                transition-all bg-red-500 rounded-full hover:bg-red-600 whitespace-nowrap shrink min-w-0"
            >
              Enquiry Form
            </Link>
          </div>

          <button
            className="p-2 ml-auto lg:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="toggle mobile menu"
          >
            {mobileMenuOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="p-4 mt-4 bg-white rounded-lg shadow-lg lg:hidden">
            <nav className="space-y-3">
              <Link to="/" onClick={() => setMobileMenuOpen(false)} className="block font-medium text-slate-800">Home</Link>
              <Link to="/services" onClick={() => setMobileMenuOpen(false)} className="block font-medium text-slate-800">Services</Link>
              <Link to="/products" onClick={() => setMobileMenuOpen(false)} className="block font-medium text-slate-800">Products</Link>
              <Link to="/innovation" onClick={() => setMobileMenuOpen(false)} className="block font-medium text-slate-800">Innovation</Link>
              <Link to="/blogs" onClick={() => setMobileMenuOpen(false)} className="block font-medium text-slate-800">Blogs</Link>
              <Link to="/about" onClick={() => setMobileMenuOpen(false)} className="block font-medium text-slate-800">About Us</Link>
              <Link to="/contact" onClick={() => setMobileMenuOpen(false)} className="block font-medium text-slate-800">Contact Us</Link>
            </nav>
            <div className="mt-4 space-y-2">
              <button
                onClick={() => { downloadBrochure(); setMobileMenuOpen(false); }}
                className="w-full px-4 py-2 font-medium border-2 rounded-full border-slate-700 text-slate-700"
              >
                Download Brochure
              </button>
              <Link
                to="/contact"
                onClick={() => setMobileMenuOpen(false)}
                className="block w-full px-4 py-2 font-medium text-center text-white bg-red-500 rounded-full"
              >
                Enquiry Form
              </Link>
            </div>
          </div>
        )}
      </header>

      {/* ✅ Modal JSX lives directly here — never remounts on state change */}
      {showModal && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
          onClick={closeModal}
        >
          <div
            className="bg-white rounded-3xl p-8 max-w-md w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-2xl font-bold text-[#3b1b0d] mb-4">Download Brochure</h3>
            <p className="text-[#7b5b3a] mb-6">Please provide your details to download our brochure</p>

            <div className="space-y-4">
              <div>
                <label className="block text-[#3b1b0d] font-medium mb-2">Name *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => updateField('name', e.target.value)}
                  className="w-full px-4 py-3 rounded-xl border-2 border-[#f2e1c5] focus:border-[#b42b2b] focus:outline-none"
                />
              </div>
              <div>
                <label className="block text-[#3b1b0d] font-medium mb-2">Email *</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => updateField('email', e.target.value)}
                  className="w-full px-4 py-3 rounded-xl border-2 border-[#f2e1c5] focus:border-[#b42b2b] focus:outline-none"
                />
              </div>
              <div>
                <label className="block text-[#3b1b0d] font-medium mb-2">Phone *</label>
                <input
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => updateField('phone', e.target.value)}
                  className="w-full px-4 py-3 rounded-xl border-2 border-[#f2e1c5] focus:border-[#b42b2b] focus:outline-none"
                />
              </div>

              <div className="flex gap-3 pt-4">
                <button
                  onClick={handleSubmit}
                  disabled={!formData.name || !formData.email || !formData.phone}
                  className="flex-1 bg-[#b42b2b] text-white px-6 py-3 rounded-full font-medium hover:bg-[#8f2222] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Download
                </button>
                <button
                  onClick={closeModal}
                  className="flex-1 bg-gray-200 text-gray-700 px-6 py-3 rounded-full font-medium hover:bg-gray-300 transition-colors"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;